export default {
	environment: 'prd',
	STUDENTAPI_BASE_URL: 'https://studentapi.prtl.co',
	PUBLIC_ROLLBAR_TOKEN: 'ef1caa400c9946809e9807efb891d8085ac1b4ed91e37911f7ca42f961ee89d5f3b73c32749a417054b76f3fcdee174f'
};
